import { useEffect, useState } from "react";
import { Form, Spinner, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setInProgressPitch } from "./redux/actions";
import createSummary from '../../../utils/openAI';
import useDebounce from "../../../hooks/useDebounce";

import "./createPitchModal.css"

const CreatePitchModal = () => {

    const inProgressPitch = useSelector(state => state.createPitch.inProgressPitch);
    const currentUser = useSelector(state => state.user.loggedInUser);

    const [pitchDescription, setPitchDescription] = useState(inProgressPitch ? inProgressPitch.pitchDescription : '');
    const [pitchTitle, setPitchTitle] = useState(inProgressPitch ? inProgressPitch.pitchTitle : "");
    const [pitchLink, setPitchLink] = useState(inProgressPitch ? inProgressPitch.pitchLink : "");
    const [pitchLevel, setPitchLevel] = useState(inProgressPitch ? inProgressPitch.pitchLevel : 1);
    const debouncedDescription = useDebounce(pitchDescription, 500);
    const debouncedTitle = useDebounce(pitchTitle, 500);
    const debouncedLink = useDebounce(pitchLink, 500);


    const [isGenerating, setIsGenerating] = useState(false);

    const dispatch = useDispatch();

    const handleAiGeneration = async () => {
        setIsGenerating(true);
        const response = await createSummary(pitchTitle);
        setIsGenerating(false);
        setPitchDescription(response);
    }

    useEffect(() => {
        if (debouncedDescription || debouncedLink || debouncedTitle) {
            dispatch(setInProgressPitch({ pitchDescription, pitchLink, pitchTitle, pitchLevel: parseInt(pitchLevel) }))
        }
    }, [debouncedDescription, debouncedLink, debouncedTitle, pitchLevel])

    return (
        <Form>
            <Form.Group className={"modalCreatePitchForm"}>
                <Form.Label>Pitch name</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Title of your idea"
                    value={pitchTitle}
                    onChange={(e) => setPitchTitle(e.target.value)}
                />
                <Form.Label>Image Link</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Link to an image"
                    value={pitchLink}
                    onChange={(e) => setPitchLink(e.target.value)}
                />
                <Form.Label>Level of Visibility</Form.Label>
                <Form.Select aria-label="Level of Visibility" value={pitchLevel} onChange={(e) => setPitchLevel(e.target.value)}>
                    <option>Level of Visibility</option>
                    <option value={1} selected="selected">Guest</option>
                    {currentUser && currentUser.level >= 100 && <option value={100}>Authorized Users</option>}
                    {currentUser && currentUser.level >= 1000 && <option value={1000}>AIE / Admin</option>}
                </Form.Select>
                <Form.Label>Pitch Description</Form.Label>
                <Form.Control
                    as="textarea"
                    placeholder="Whats your dream?"
                    value={pitchDescription}
                    maxLength={500}
                    rows={7}
                    onChange={(e) => setPitchDescription(e.target.value)}
                />
                <Form.Text className="text-muted">
                    Maximum 500 Characters.
                </Form.Text>
                <section className={"aiSection"}>
                    <section>
                        <p>Need help with coming up with a description? Use the AI generator!</p>
                        <Form.Text className="text-muted">
                            Write a title then press the button and the magic will happen! Please edit all the fields before sending!
                        </Form.Text>
                    </section>
                    <Button variant='outline-primary' disabled={pitchTitle.length < 3} onClick={handleAiGeneration}>{isGenerating ?
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Generating....</span>
                        </Spinner> : 'Create with AI!'}</Button>
                </section>
            </Form.Group>
        </Form>
    )
}

export default CreatePitchModal;